import styled from '@emotion/styled';
import { Content } from '@radix-ui/react-dialog';

import { SplashPage } from '../../containers/SplashPage';

export const OverlayContent = styled(Content)`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndices.top + 1};
`;

export const WebAuthnOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0 0 0 / 60%);
  backdrop-filter: blur(15px);
`;

export const PinAuthOverlay = styled(SplashPage)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background};
`;
